import { render, staticRenderFns } from "./AdminGliderForm.vue?vue&type=template&id=033a9c82"
import script from "./AdminGliderForm.vue?vue&type=script&lang=ts"
export * from "./AdminGliderForm.vue?vue&type=script&lang=ts"
import style0 from "./AdminGliderForm.vue?vue&type=style&index=0&id=033a9c82&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports